import { AutoComplete } from "antd";
import { useIntl } from "react-intl";

import { useOrganizationSelect } from "./hooks";
import { OrganizationSelectProps } from "./types";

const OrganizationSelect: React.FC<OrganizationSelectProps> = ({
  value,
  onChange,
  ...props
}) => {
  const intl = useIntl();
  const select = useOrganizationSelect({ value, onChange });

  return (
    <AutoComplete
      {...select}
      placeholder={intl.formatMessage({
        defaultMessage: "Choose Organization",
      })}
      {...props}
    />
  );
};

export default OrganizationSelect;
